module.exports = __webpack_public_path__ + "img/game_4.ced26619.jpg";